// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1ZM1N","label":"Labeled_label__aW3-s","divider":"Labeled_divider__2jXv3"};